
<template>
 <div class="row clearfix">
    <div class="col-md-12 col-lg-12">
      <div class="card">
        <div class="body" v-if="!editApp">
          <div class="body planned_task">
            <div class="dd" data-plugin="nestable">
              <div class="header">
                <h2><strong>버전 관리 </strong></h2>
                <div class="header-dropdown">
                  <!-- <button class="btn btn-default" type="button" @click="toEditPage" >수정</button> -->
                  <button
                    class="btn btn-default"
                    type="button"
                    @click="cloneVersion"
                  >
                    복제
                  </button>
                  <!-- <button class="btn btn-primary" type="button" >삭제</button> -->
                </div>
              </div>

              <div class="table-responsive" style="overflow: inherit">
                <table
                  class="table table-hover mb-0"
                  style="text-align: center"
                >
                  <thead>
                    <tr>
                      <th class="border-top-0">#</th>
                      <th class="border-top-0">버전</th>
                      <th class="border-top-0">상태</th>
                      <th class="border-top-0"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(list, index) in appList" v-bind:key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ list.versionCode }}</td>
                      <td>{{ getVersionVisible(list.viewYn )}}</td>
                      <td style="text-align: center">
                        <!-- <button
                                                    class=" btn "
                                                    @click="showDropList"
                                                    >
                                                    <span class="dropdown "  role="button"  data-toggle="dropdown" aria-expanded="false" aria-haspopup="true">
                                                        <i class="zmdi zmdi-settings"></i>
                                                        <ul class="dropdown-menu dropdown-menu-right" :class="{show : dropdown}" >
                                                            <li><a href="javascript:void(0);" >수정</a></li>
                                                            <li><a href="javascript:void(0);" @click="cloneVersion" >복제</a></li>
                                                            <li> -->
                        <a
                          href="javascript:void(0);"
                          @click="deleteVersion(index)"
                          >삭제</a
                        >
                        <!-- </li> -->
                        <!-- </ul> -->
                        <!-- </span> -->
                        <!-- </button> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="btn btn-default"  v-if="editApp" @click="closeEditPage">뒤로</button> -->
        <!-- <dev-new-app v-if="editApp" v-bind:nowPage="'version'"/> -->
      </div>
      <!-- <paginate /> -->
    </div>

    <!-- Default Size -->

    <div
      class="modal"
      :class="{ fade: booleanModal, show: booleanModal }"
      id="defaultModal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="title" id="defaultModalLabel">버전 관리</h4>
          </div>
          <div class="modal-body">
            <div class="row clearfix">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="body">
                  <div class="row clearfix">
                    <div class="col-sm-6">
                      <select class="form-control show-tick">
                        <!-- 여기에 버전 전체 목록 띄우기 .. -->
                        <option value="">{{ currentVersion }}</option>
                      </select>
                    </div>
                    <div class="col-sm-6">
                      <select class="form-control" v-model="selectVersion">
                        <!-- <option value="">new version</option> -->
                        <option :value="patchVersion">
                          {{ patchVersion }}
                        </option>
                        <option :value="minorVersion">
                          {{ minorVersion }}
                        </option>
                        <option :value="majorVersion">
                          {{ majorVersion }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary waves-effect"
              @click="cloneSave"
              :disabled="saveBtn"
            >
              저장
            </button>
            <button
              type="button"
              class="btn btn-default btn-simple waves-effect"
              data-dismiss="modal"
              @click="closeModal"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Urls from "@/common/urls";
import Apiroot from "@/common/apiroot";
import eventbus from "@/store/modules/devEventBus";

export default {
  name: "DevVersion",
  components: {
    //   'paginate' : paginate
    // 'devNewApp' : devNewApp
  },
  data() {
    return {
      dropdown: false,
      booleanModal: false,

      currentVersion: null,
      selectVersion: this.currentVersion,

      patchVersion: null,
      minorVersion: null,
      majorVersion: null,

      appList: null,
      editApp: false,
      saveBtn : false,
    };
  },
  methods: {
    getVersionVisible(view){
      if(view == 'Y'){
        return '공개';

      } else if(view == 'N') {
        return '비공개';
      }

    },
    showDropList() {
      console.log(this.dropdown);
      this.dropdown = !this.dropdown;
    },
    cloneVersion() {
      console.log("복제,..");
      this.booleanModal = true;
    },
    closeModal() {
      this.booleanModal = false;
    },
    toEditPage() {
      this.editApp = true;
      console.log(this.$store.state.devStore.apiData);

      // 여기 appcode 하고 appid 묶어주기?!
      // this.$store.state.devStore.appCode = this.$store.state.devStore.appCode
      // this.$router.push({name : 'DevNewAppEdit', params : {appCode : code, appId : value}})
    },
    closeEditPage() {
      this.editApp = false;
      eventbus.$emit("closeVersionEdit");
    },

    cloneSave() {

      this.saveBtn = true

      var param = {
        appCode: this.$store.state.devStore.appData.appCode,
        userCode: this.$store.state.userStore.userCode,
        versionCode: this.selectVersion,
        previousVersion : this.currentVersion
      };

      this.api.appClone(param)
        .then(() => {
         

          var param = {
            appCode: this.$store.state.devStore.appCode,
          };

          this.api.appVersions(param)
            .then((res) => {
              console.log(res.app);

              this.$store.state.devStore.appData = res.app[0];
              this.currentVersion =
                this.$store.state.devStore.appData.versionCode;

              this.patchVersion =
                this.currentVersion.split(".")[0] +
                "." +
                this.currentVersion.split(".")[1] +
                "." +
                (Number(this.currentVersion.split(".")[2]) + 1);
              this.minorVersion =
                this.currentVersion.split(".")[0] +
                "." +
                (Number(this.currentVersion.split(".")[1]) + 1) +
                ".0";
              this.majorVersion =
                Number(this.currentVersion.split(".")[0]) + 1 + ".0.0";
              console.log(this.currentVersion);

              this.appList = res.app;

              this.saveBtn = false


              this.$store
                .dispatch("apiSetting")
                .then(() => {
                  this.authList = this.$store.state.devStore.apiAuth;
                  this.trigList = this.$store.state.devStore.apiTrig;
                  this.actList = this.$store.state.devStore.apiAct;


                   this.booleanModal = false;

                   this.$router.push({name : 'DevelopPage'})



                })
                .catch(() => alert("오류가 발생했습니다. dev trig setting"));
            })
            .catch(() => alert("오류가 발생했습니다."));
        })
        .catch(() => alert("오류가 발생했습니다."));
    },
    deleteVersion(index) {
      if(confirm('버전을 삭제하시겠습니까? 삭제 후 메인 페이지로 이동됩니다.')){
        console.log(this.appList[index]);
        var param = {
          appCode: this.$store.state.devStore.appData.appCode,
          // userCode : this.$store.state.userStore.userCode,
          versionCode: this.appList[index].versionCode,
        };



          this.api.appRemove(param)
          .then(() => {
            // this.reloadLists();
            this.$router.push({name : 'DevelopPage'})


          })
          .catch(() => alert("오류가 발생했습니다."));

      }

    },
    reloadLists() {
      var param = {
        appCode: this.$store.state.devStore.appCode,
      };

      this.api.appVersions(param)
        .then((res) => {
          console.log("app 불러롬 : ", res.app);

          if (res.app.length > 0) {
            this.appList = res.app;

            var param = {
              userCode: this.$store.state.userStore.userCode,
              appCode: res.app[0].appCode,
            };

            this.api.appDetail()

            this.$store
              .dispatch("postSend", {
                paths: Apiroot.app + Urls.appDetail,
                params: param,
              })
              .then((res) => {
                console.log("결과값:", res);

                this.$store.state.devStore.appData = res.app;
                console.log(res.app);
                console.log(this.$store.state.devStore.appData);

                this.setAppDetails();
              })
              .catch(() => alert("오류가 발생했습니다. app detail"));
          } else {
            this.$router.push({ name: "DevApps" });
          }
        })
        .catch(() => alert("오류가 발생했습니다."));
    },
    setAppDetails() {
      this.$store
        .dispatch("apiSetting")
        .then(() => {
          this.authList = this.$store.state.devStore.apiAuth;
          this.trigList = this.$store.state.devStore.apiTrig;
          this.actList = this.$store.state.devStore.apiAct;

          console.log(this.$store.state.devStore.appData);
        })
        .catch(() => alert("오류가 발생했습니다. dev trig setting"));
    },
  },
  created() {
    console.log("DevVersion.created");

    var param = {
      appCode: this.$store.state.devStore.appCode,
    };

    this.$store
      .dispatch("postSend", {
        paths: Apiroot.app + Urls.appVersions,
        params: param,
      })
      .then((res) => {
        console.log(res.app);

        this.appList = res.app;
      })
      .catch(() => alert("오류가 발생했습니다."));

    if (this.$store.state.devStore.appData.versionCode != null) {
      this.currentVersion = this.$store.state.devStore.appData.versionCode;

      console.log(this.currentVersion.split("."));

      this.patchVersion =
        this.currentVersion.split(".")[0] +
        "." +
        this.currentVersion.split(".")[1] +
        "." +
        (Number(this.currentVersion.split(".")[2]) + 1);
      this.minorVersion =
        this.currentVersion.split(".")[0] +
        "." +
        (Number(this.currentVersion.split(".")[1]) + 1) +
        ".0";
      this.majorVersion =
        Number(this.currentVersion.split(".")[0]) + 1 + ".0.0";
      console.log(this.currentVersion);
      console.log(this.patchVersion);
    }
    
  },
  mounted() {
    console.log("DevVersion.mounted");
  },
  beforeDestroy() {
    console.log("DevVersion.beforeDestroy");
  }
}
</script>
